import { render, staticRenderFns } from "./TrendingIndicesWidgetWrapper.vue?vue&type=template&id=5486d0f7"
import script from "./TrendingIndicesWidgetWrapper.vue?vue&type=script&lang=js"
export * from "./TrendingIndicesWidgetWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
